import script from "./CategorydetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorydetailView.vue?vue&type=script&setup=true&lang=js"

import "./CategorydetailView.vue?vue&type=style&index=0&id=f8222998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8222998"]])

export default __exports__